import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {
  changeCampaignData,
  getCampaignTypesView,
  getCampaignTypes,
  getUserTypesAccount,
  getIndistries,
  getPaineis,
  getLanguages
} from '../../../actions/campaignActions'
import { translate } from '../../../components/Translate'

export class Campaign extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
    this.state = {
    uploading: false,
    };

  }
getTypeMedia(mimeType) {
    if (mimeType.includes('video')) return 'video';
    if (mimeType.includes('image')) return 'image';
    if (mimeType.includes('audio')) return 'audio';
    return 'url';
  }
  onChange(e) {
    
    
	const { name, value } = e.target;
	const data = { ...this.props.campaignData, [name]: value };
	this.props.changeCampaignData(data);
	this.props.updateMyState();
	this.setState({ update: true });
  }
  
onChangeFile(e) {
  const file = e.target.files[0];
const mediaType = this.props.campaignData['media_type']; 

  if (file) {
    console.log('estou dentro do if')
    const previewUrl = URL.createObjectURL(file);
    
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.src = previewUrl;
    video.onloadedmetadata = () => {
      const duration = video.duration;
      
      const data = {
        ...this.props.campaignData,
        campaign_video: file,
        campaign_media_preview: previewUrl,
        duration: duration,
        type_video: this.getTypeMedia(file.type),
      };

      this.props.changeCampaignData(data);
      this.props.updateMyState();
      this.setState({ update: true });

     
    };
   if (file.type=='image/png') {
    const duration = 10;
    const data = {
        ...this.props.campaignData,
        campaign_video: file,
        campaign_media_preview: previewUrl,
        duration: duration,
        type_video: this.getTypeMedia(file.type),
      };
      this.props.changeCampaignData(data);
      this.props.updateMyState();
      this.setState({ update: true });
   }
  }
}



  
async componentDidMount() {
  await this.props.getCampaignTypesView();
  await this.props.getCampaignTypes();
  await this.props.getIndistries();
  await this.props.getUserTypesAccount();
  await this.props.getPaineis();
  await this.props.getLanguages();

  const data = { ...this.props.campaignData };

  if (!data.media_type && data.campaign_video) {
  const value = data.campaign_video;

  if (typeof value === 'string') {
    const ext = value.split('.').pop().toLowerCase();

    if (value.startsWith('http')) {
      if (ext.match(/mp4|webm|ogg/)) {
        data.media_type = 'video';
      } else if (ext.match(/jpg|jpeg|png|gif/)) {
        data.media_type = 'image';
      } else if (ext.match(/mp3|wav|ogg/)) {
        data.media_type = 'audio';
      } else {
        data.media_type = 'url';
        data.campaign_media_url = value; // <-- ADICIONE ISTO
      }

      data.campaign_media_preview = value;
    }
  }

  this.props.changeCampaignData(data);
}


  this.setState({ update: true });
}

  escolhaDaCampanha = async (index, item) => {
    await this._removeContato(index, item);
    this.setState({ update: true });
    this.props.updateMyState()
  }

  _removeContato = index => {
	const data = { ...this.props.campaignData, contacts: [] };
	this.props.changeCampaignData(data);
	this.setState({ update: true });
  }
  

  render() {
  const { campaignData, accounts, paineis, themes } = this.props;

    return (
      <fieldset>
        <div className="form-row">
          <div className="form-group col-md-2">
            <label>{translate('Anunciante')}</label>
            <input type="text" className="form-control text-uppercase" placeholder={translate("Anunciante")} name="advertiser" onChange={this.onChange} value={campaignData['advertiser']} required disabled={!campaignData['can_edit']} />
          </div>

          <div className="form-group col-md-2">
            <label>{translate('Produto')}</label>
            <select className="form-control" name="campaign_types_view_id" onChange={this.onChange} value={campaignData['campaign_types_view_id']} disabled={!campaignData['can_edit']} required>
              <option value=''>{translate('Selecione um Produto')}</option>
              {
                this.props.campaignTypesView.map(campaignTypesView => (
                  <option value={campaignTypesView.campaign_types_view_id} key={campaignTypesView.campaign_types_view_id}>
                    {campaignTypesView.type_campaign}
                  </option>
                ))
              }
            </select>
          </div>

          <div className={['1', '5', ''].indexOf(campaignData['campaign_types_view_id']) === -1 ? "form-group col-md-2" : "d-none"}>
            <label>{translate('Painel')}</label>
            <select className="form-control" name="painel_id" onChange={this.onChange} value={campaignData['painel_id']} disabled={!campaignData['can_edit']} {...(['1', '5', ''].indexOf(campaignData['campaign_types_view_id']) === -1 ? { required: true } : {})}>
              <option value=''>{translate('Selecione um Painel')}</option>
              {
                this.props.paineis.map(painel => (
                  <option value={painel.painel_id} key={painel.painel_id}>{painel.description}</option>
                ))
              }
            </select>
          </div>

          <div className="form-group col-md-4">
            <label>{translate('Título')}</label>
            <input type="text" className="form-control text-uppercase" placeholder={translate("Título da Pesquisa")} name="name" onChange={this.onChange} value={campaignData['name']} required disabled={!campaignData['can_edit']} />
          </div>

          <div className={['1', '5', ''].indexOf(campaignData['campaign_types_view_id']) === -1 ? "form-group col-md-2" : "form-group col-md-4"}>
            <label>{translate('Industria')}</label>
            <select className="form-control" name="industry_id" onChange={this.onChange} value={campaignData['industry_id']} disabled={!campaignData['can_edit']} required>
              <option value=''>{translate('Selecione uma Indústria')}</option>
              {
                this.props.industries.map(industry => (
                  <option value={industry.industry_id} key={industry.industry_id}>{translate(industry.description)}</option>
                ))
              }
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label>{translate('Início')}</label>
            <input type="date" className="form-control" name="start" onChange={this.onChange} value={campaignData['start']} required />
          </div>
          <div className="form-group col-md-4">
            <label>{translate('Fim')}</label>
            <input type="date" className="form-control" name="end" onChange={this.onChange} value={campaignData['end']} required />
          </div>
          <div className="form-group col-md-2">
            <label>{translate('Tipo')}</label>
            <select className="form-control" name="campaign_type_id" disabled={!campaignData['can_edit']} onChange={this.onChange} value={campaignData['campaign_type_id']} required>
              <option value=''>{translate('Selecione um Tipo')}</option>
              {
                this.props.campaignTypes.map(campaign_type => (
                  <option value={campaign_type.campaign_type_id} key={campaign_type.campaign_type_id}>{campaign_type.description}</option>
                ))
              }
            </select>
          </div>

          <div className="form-group col-md-2">
            <label>{translate('Idioma')}</label>
            <select className="form-control" name="language" disabled={!campaignData['can_edit']} onChange={this.onChange} value={campaignData['language']} required>
              <option value=''>{translate('Selecione um Idioma')}</option>
              {
                this.props.languages.map(language => (
                  <option value={language} key={language}>{translate(language)}</option>
                ))
              }
            </select>
          </div>

          <div className="form-group col-md-2">
            <label>{translate('Tema')}</label>
            <select className="form-control" name="theme" onChange={this.onChange} value={campaignData['theme']} required>
              <option value=''>{translate('Selecione um Tema')}</option>
              {
                themes.map(element => (
                  <option value={element.value} key={element.value}>{element.label}</option>
                ))
              }
            </select>
          </div>
        </div>

        <div className="form-row">

          {['2', '3'].includes(campaignData.campaign_types_view_id) && (
          <div className="form-group col-md-2">
            <label>{translate('Tipo de Mídia')}</label>
            <select
              className="form-control"
              name="media_type"
              value={campaignData['media_type'] || ''}
              onChange={this.onChange}
            >
              <option value="">{translate('Selecione')}</option>
              <option value="video">Vídeo</option>
              <option value="image">Imagem</option>
              <option value="audio">Áudio</option>
              <option value="url">URL</option>
            </select>
          </div>

          )}
          {campaignData['media_type'] && ['video', 'image', 'audio'].includes(campaignData['media_type']) ? (
          <div className="form-group col-md-4">
            <label>{translate('Upload de')} {translate(campaignData['media_type'])}</label>
            <input
              type="file"
              accept={
                campaignData['media_type'] === 'video'
                  ? 'video/*'
                  : campaignData['media_type'] === 'image'
                  ? 'image/*'
                  : 'audio/*'
              }
              className="form-control"
              name="campaign_video"
              onChange={this.onChangeFile}
              style={{
                display: 'block',
                opacity: 1,
                position: 'static',
                visibility: 'visible',
                zIndex: 'auto',
                height: '36px',
              }}
            />
          </div>
          ) : null}

          {campaignData['media_type'] === 'url' && (
            <div className="form-group col-md-4">
              <label>{translate('Insira a URL')}</label>
              <input
                type="url"
                className="form-control"
                name="campaign_media_url"
                onChange={this.onChange}
                value={campaignData['campaign_media_url'] || ''}
              />
            </div>
          )}
        </div>

        {campaignData['media_type'] && (
        <div className="form-group col-md-4" style={{ maxWidth: '90%', maxWidth:'100%' }}>
            {campaignData['media_type'] === 'image' && (
              <img
                src={campaignData['campaign_media_preview'] || campaignData['campaign_video']}
                alt="preview"
                style={{ maxWidth: '100%' }}
              />
            )}

           {campaignData['media_type'] === 'video' &&
 (campaignData['campaign_media_preview'] || campaignData['campaign_video']) && (
  <video
    controls
    src={campaignData['campaign_media_preview'] || campaignData['campaign_video']}
    style={{ width: '40%', height:'40%' } }
  />
)}


            {campaignData['media_type'] === 'audio' &&
 (campaignData['campaign_media_preview'] || campaignData['campaign_video']) && (
  <audio
    controls
    src={campaignData['campaign_media_preview'] || campaignData['campaign_video']}
    style={{ width: '100%' }}
  />
)}


            {campaignData['media_type'] === 'url' && campaignData['campaign_media_preview'] && (
              <div className="form-group col-md-4">
                <iframe
                  src={campaignData['campaign_media_preview']}
                  title="Preview"
                  style={{ width: '100%', height: '300px', border: '1px solid #ccc', borderRadius: '8px' }}
                />
              </div>
            )}

          </div>
        )}
        <div className="form-row">
          <div className="form-group col-md-2">
            <h4 className="card-title">{translate('Permissionamento')}</h4>
            <label>{translate('Por conta')}:</label>
            <select className="form-control" name="account_id" onChange={this.onChange} value={campaignData['account_id']} onClick={this.escolhaDaCampanha}  >
              <option value='' >{translate('Selecione uma Conta')}</option>
              {
                this.props.accounts.map(account => (
                  <option value={account.account_id} key={account.account_id}>{account.name}</option>
                ))
              }
            </select>
          </div>
        </div>
      </fieldset>
    );
  }
}

const mapStateToProps = store => ({
  campaignData: store.campaign.current,
  campaignTypes: store.campaign.campaign_types,
  industries: store.campaign.industries,
  campaignTypesView: store.campaign.campaign_types_view,
  accounts: store.campaign.account,
  paineis: store.campaign.paineis,
  languages: store.campaign.languages,
  themes: store.campaign.themes,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeCampaignData,
    getCampaignTypesView,
    getCampaignTypes,
    getIndistries,
    getUserTypesAccount,
    getPaineis,
    getLanguages
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Campaign);
